import type React from 'react'

interface RigtDoubleChevronIconProps {
  size?: number | string
  color?: string
  className?: string
}

const RigtDoubleChevronIcon: React.FC<RigtDoubleChevronIconProps> = ({ size = 24, color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={'Rigt Double Chevron Icon'}
      role="img"
    >
      <path
        d="M12.941 19.0421C12.6969 19.2861 12.3013 19.2861 12.0572 19.0421C11.8132 18.798 11.8132 18.4023 12.0572 18.1583L17.491 12.7245C17.8882 12.3269 17.8884 11.6726 17.491 11.2751L12.0572 5.8422C11.8132 5.59817 11.8133 5.2025 12.0572 4.95841C12.3013 4.71434 12.6969 4.71434 12.941 4.95841L18.3748 10.3914C19.2605 11.2771 19.2605 12.7234 18.3748 13.6091L12.941 19.0421Z"
        fill={color}
      />
      <path
        d="M5.56796 19.0421C5.32388 19.2861 4.92823 19.2861 4.68417 19.0421C4.44018 18.798 4.44018 18.4023 4.68417 18.1583L10.1179 12.7245C10.5152 12.3269 10.5154 11.6726 10.1179 11.2751L4.68417 5.8422C4.44014 5.59817 4.44022 5.2025 4.68417 4.95841C4.92825 4.71434 5.32388 4.71434 5.56796 4.95841L11.0017 10.3914C11.8874 11.2771 11.8875 12.7234 11.0017 13.6091L5.56796 19.0421Z"
        fill={color}
      />
    </svg>
  )
}

export default RigtDoubleChevronIcon
